import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaExpand, FaTimes } from "react-icons/fa";
import "./Gallery.css";

/* ASSETS */
import finalBanner from "../assets/finalbanner.png";

import s1 from "../assets/services-1.jpg";
import s2 from "../assets/services-2.jpg";
import s3 from "../assets/services-3.jpg";
import s4 from "../assets/services-4.jpg";
import s5 from "../assets/services-5.jpg";
import s6 from "../assets/services-6.jpg";
import s7 from "../assets/services-7.jpg";
import s8 from "../assets/services-8.jpg";
import s9 from "../assets/services-9.jpg";
import s10 from "../assets/services-10.jpg";
import s11 from "../assets/services-11.jpg";
import s12 from "../assets/services-12.jpg";
import s13 from "../assets/services-13.jpg";
import s14 from "../assets/services-14.jpg";
import s15 from "../assets/services-15.jpg";
import s16 from "../assets/services-16.jpg";
import s17 from "../assets/services-17.jpg";
import s18 from "../assets/services-18.jpg";
import s19 from "../assets/services-19.jpg";

const images = [
  s1, s2, s3, s4, s5, s6, s7, s8, s9,
  s10, s11, s12, s13, s14, s15, s16, s17, s18, s19
];

const Gallery = () => {
  const [selected, setSelected] = useState(null);

  /* ESC key close */
  useEffect(() => {
    const escHandler = (e) => {
      if (e.key === "Escape") setSelected(null);
    };
    window.addEventListener("keydown", escHandler);
    return () => window.removeEventListener("keydown", escHandler);
  }, []);

  return (
    <div className="gallery-page-root">

      {/* ===== HERO ===== */}
<section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
  OUR GALLERY
</motion.h1>

  </div>
</section>

      {/* ===== GRID ===== */}
      <section className="gallery-grid-section">
        <div className="gallery-grid">
          {images.map((img, index) => (
            <motion.div
              key={index}
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              onClick={() => setSelected(img)}
            >
              <img src={img} alt={`Gallery ${index}`} />
              <div className="gallery-hover">
                <FaExpand />
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ===== LIGHTBOX ===== */}
      <AnimatePresence>
        {selected && (
          <motion.div
            className="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <motion.div
              className="gallery-lightbox-box"
              initial={{ scale: 0.85 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.85 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="gallery-close"
                onClick={() => setSelected(null)}
              >
                <FaTimes />
              </button>

              <img src={selected} alt="Preview" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
